<script>
import CookieLaw from "vue-cookie-law";

export default {
  name: "landing-footer",
  data() {
    return {};
  },
  components: {
    CookieLaw
  },
  methods: {
    scrollIntoView(id) {
      document.getElementById(id).scrollIntoView();
    }
  }
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <a href="#" class="logo-footer">
              <img
                src="@/assets/img/mandaa/logo-light.png"
                height="50"
                alt=""
                class="mb-3"
              />
            </a>
            <br />
            <span class="mt-4">{{ $t("landing:footer.address") }}</span>
            <br />
            <span class="mt-1"><strong>CIF:</strong> F01669043</span>
            <br />
            <span class="mt-0">+34 622 806 452</span>
            <br />
            <span class="mt-0">info@mandaa.net</span>
          </div>
          <div class="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">
              {{ $t("landing:footer.company.title") }}
            </h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <a @click="scrollIntoView('prices')" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i>
                  {{ $t("landing:footer.company.pricing") }}
                </a>
              </li>
              <li>
                <router-link to="/contact" class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i>
                  {{ $t("landing:footer.company.contact-us") }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <footer class="footer footer-bar">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-sm-6">
            <div class="text-sm-left">
              <p class="mb-0">
                © {{ new Date().getFullYear() }} {{ $t("landing:title") }}.
                {{ $t("landing:footer.copyright") }}
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <ul class="list-unstyled text-sm-right mb-0">
              <li class="list-inline-item">
                <a href="javascript:void(0)"
                  ><img
                    src="@/assets/img/landrick/payments/american-ex.png"
                    class="avatar avatar-ex-sm"
                    title="American Express"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="@/assets/img/landrick/payments/discover.png"
                    class="avatar avatar-ex-sm"
                    title="Discover"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="@/assets/img/landrick/payments/master-card.png"
                    class="avatar avatar-ex-sm"
                    title="Master Card"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="@/assets/img/landrick/payments/paypal.png"
                    class="avatar avatar-ex-sm"
                    title="Paypal"
                    alt=""
                /></a>
              </li>
              <li class="list-inline-item ml-1">
                <a href="javascript:void(0)"
                  ><img
                    src="@/assets/img/landrick/payments/visa.png"
                    class="avatar avatar-ex-sm"
                    title="Visa"
                    alt=""
                /></a>
              </li>
            </ul>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
      <cookie-law>
        <div slot-scope="props">
          {{ $t("cookiesPolicy:cookies.text") }}
          <router-link to="cookies">{{
            $t("cookiesPolicy:cookies.text_href")
          }}</router-link>
          <a class="btn mb-3 ml-5 btn-primary btn-md" @click="props.accept"
            ><span>{{ $t("cookiesPolicy:cookies.buttons.accept") }}</span></a
          >
        </div>
      </cookie-law>
    </footer>
    <!--end footer-->
  </div>
</template>
